import { useEffect, useState } from 'react';

import { IContent, folderApi, TFolder } from '@_entities/content';

import { useUILayerStore } from '@_shared/stores/useUILayerStore';

import { FolderUpdateModal } from '../../ui';

export function useFolderUpdateModal(
	content: IContent,
	folderId: number,
	isFolderDetailPage: boolean,
) {
	const { pushLayer } = useUILayerStore();
	const [folderlist, setFolderlist] = useState<TFolder[]>([]);

	useEffect(() => {
		folderApi.getFolderList(true, 'manual').then(({ data }) => {
			setFolderlist(data);
		});
	}, []);

	const openFolderUpdateModal = () => {
		pushLayer(
			'modal',
			<FolderUpdateModal
				folderlist={folderlist}
				folderId={folderId}
				content={content}
				isFolderDetailPage={isFolderDetailPage}
			/>,
		);
	};

	return {
		openFolderUpdateModal,
	};
}
